export default __webpack_public_path__ + "static/media/shop.b68461ba.jpg";